// extracted by mini-css-extract-plugin
export var fadeIn = "_jc-1";
export var modalContent = "_jc-3";
export var overlay = "_jc-0";
export var popoverContent = "_jc-2";
export var results = "_jc-5";
export var searchInputWrapper = "_jc-4";